import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    padding: 20px 20px 0 20px;
    height: 100%;
`;

export const VerticalSpace = styled.div`
    flex: 1;
    min-height: 30px;
`;

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: stretch;
    margin-bottom: 2px;
`;

export const Section = styled.div`
    color: #999;
    font-size: 12px;
    text-transform: uppercase;
    height: 12px;

    &.confirmationLabel {
        margin: 10px 0 0 10px;
    }

    &.spaceshared {
        flex: 1;
    }
`;

export const SectionCollapse = styled.div`
    color: #777;
    font-size: 12px;
    text-transform: uppercase;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
`;

export const CollapseState = styled.div`
    width: 20px;
    height: 20px;
    color: #999;
    font-size: 18px;
    position: relative;

    &:before {
        content: '\\F0140';
        font-family: 'Material Design Icons';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
    }

    &.collapsed:before {
        content: '\\F0142'
    }
`;



export const ActionButtonWrapper = styled.div`
    width: 100%;
    margin: 5px 0 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
    height: 35px;
    min-height: 35px;

    &.spaceshared {
        width: auto;
        flex: 1;
    }
`;

export const ActionButton = styled.div.attrs(props => ({
    style: props.width ? {
        width: props.width
    } : {
        flex: 1
    }
}))`
    height: 30px;
    background-color: transparent;
    border: 1px solid ${props => props.color};
    color: ${props => props.color};
    transition: all .4s ease 0s;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    &:hover,
    &.active {
        background-color: ${props => props.color};
        color: #000;
    }

    &:not(:first-child) {
        margin-left: 10px;
    }

    &.disabled {
        opacity: 0.4;
        cursor: default;
    }
`;

export const ExtraActions = styled.div`
    position: relative;
    width: 20px;
    height: 20px;
    color: ${props => props.color ?? '#04f'};
    font-size: 24px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    transition: all .5s ease 0s;
    
    &:before {
        content: '${props => props.icon}';
        font-family: "Material Design Icons";
    }

    ${ActionButton}:hover &,
    ${ActionButton}.active & {
        color: #000;
    }
`;

export const CheckboxWrapper = styled.div`
    background-color: #222;
    position: absolute;
    top: 50%;
    left: 50%;
    zIndex: 2;
    transform: translate3d(-50%, -50%, 0);
`;

export const ConfirmMessage = styled.div`
    width: 50%;
`;

export const TokenIndicator = styled.div`
    width: 15px;
    height: 15px;
    border-radius: 7.5px;
    background-color: #0f0;
    color: #000;
    margin: -4px 5px 0 0;
    position: relative;

    &:before {
        content: '\\F034E';
        font-family: "Material Design Icons";
        font-size: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
`;